import { render, staticRenderFns } from "./header2.vue?vue&type=template&id=44359e38&scoped=true"
import script from "./header2.vue?vue&type=script&lang=js"
export * from "./header2.vue?vue&type=script&lang=js"
import style0 from "./header2.vue?vue&type=style&index=0&id=44359e38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44359e38",
  null
  
)

export default component.exports